module.exports = __webpack_public_path__ + "static/media/ofertas-shell-select-footer-banner.ae4c55dd.png";